import { render, staticRenderFns } from "./ConfirmationWindow.vue?vue&type=template&id=06f29b91"
import script from "./ConfirmationWindow.vue?vue&type=script&lang=js"
export * from "./ConfirmationWindow.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationWindow.vue?vue&type=style&index=0&id=06f29b91&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports